import PropTypes from 'prop-types';
var LINK_SHAPE = {
  name: PropTypes.string.isRequired,
  href: PropTypes.string,
  highlight: PropTypes.bool,
  isOpen: PropTypes.bool,
  active: PropTypes.bool,
  onToggle: PropTypes.func,
  onNavigate: PropTypes.func,
  identityHost: PropTypes.string,
  consumerHost: PropTypes.string,
  payHost: PropTypes.string,
  isNew: PropTypes.bool
};
LINK_SHAPE.links = PropTypes.arrayOf(PropTypes.shape(LINK_SHAPE));
export default LINK_SHAPE;